module.exports = __webpack_public_path__ + "static/media/step5.99b3a312.png";